import React from 'react';
import PropTypes from 'prop-types';

import { ExpansionPanel as MuiExpansionPanel } from '@material-ui/core';

const ExpansionPanel = ({ children, ...rest }) => {
  return (
    <MuiExpansionPanel
      {...rest}
    >
      { children }
    </MuiExpansionPanel>
  )
}

ExpansionPanel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ExpansionPanel;



// WEBPACK FOOTER //
// ./src/components/base/ExpansionPanel/ExpansionPanel.js